/**
 * Route for `advertiser-campaign-upload`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserCampaignUploadPage } from "../features/advertiser-campaign-upload/AdvertiserCampaignUploadPage";

export const advertiserCampaignUploadRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-campaign-upload",
	component: AdvertiserCampaignUploadPage,
});

export default advertiserCampaignUploadRoute;
